<template>
  <div :class="`container ${dialog ? '':'h-100'} customer-seller-container`">
    <div class="content">
      <div class="header search-form">
        <el-form :model="searchCondition" :inline="true" class="form" size="mini">
          <el-form-item label="客户名称">
            <el-input v-model="searchCondition.customer_name" placeholder="请输入客户名称"
                      @change="onSubmit" clearable></el-input>
          </el-form-item>
          <el-form-item :label="'销\u3000\u3000售'">
            <el-input v-model="searchCondition.sale" placeholder="请输入销售"
                      @change="onSubmit" clearable/>
          </el-form-item>
          <el-form-item label="集团名称">
            <el-input v-model="searchCondition.combine_name" placeholder="请输入集团名称"
                      @change="onSubmit" clearable/>
          </el-form-item>
          <el-form-item label="客户性质">
            <el-select v-model="searchCondition.nature" placeholder="请选择客户性质" clearable
                       class="input-m" @change="onSubmit" style="width: 140px;">
              <el-option
                  v-for="nature in customer_natures"
                  :key="nature"
                  :label="nature"
                  :value="customer_natures[nature]"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户行业">
            <el-select v-model="searchCondition.type" placeholder="请选择客户行业" clearable
                       class="input-m" @change="onSubmit" style="width: 140px;">
              <el-option
                  v-for="type in customer_types"
                  :key="type"
                  :label="type"
                  :value="customer_types[type]"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户级别">
            <el-select v-model="searchCondition.grade" placeholder="请选择客户级别" clearable
                       class="input-m" @change="onSubmit" style="width: 140px;">
              <el-option
                  v-for="grade in customer_grades"
                  :key="grade"
                  :label="grade"
                  :value="customer_grades[grade]"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="年框">
            <el-checkbox-group v-model="searchCondition.year_frame" @change="onSubmit">
              <el-checkbox label="Y">是</el-checkbox>
              <el-checkbox label="N">否</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="合作状态">
            <el-checkbox-group v-model="searchCondition.is_new" @change="onSubmit">
              <el-checkbox label="U">未合作</el-checkbox>
              <el-checkbox label="Y">新客</el-checkbox>
              <el-checkbox label="N">老客</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="el-button--operation"
                       style="margin-left:20px;" @click="onSubmit">查询
            </el-button>
            <el-button @click="onReset" style="margin-right:0;">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div style="text-align: left;margin-bottom: 8px;">
        <el-button size="mini" @click="goCustom" type="primary" v-if="userAuth.can_create_customer_info"
                   icon="el-icon-plus">
          添加客户
        </el-button>
        <export-btn size="mini" :can-export="userAuth.can_export_customer_info"
                    @export="exportExcel('refExportBtn')" ref="refExportBtn" :lint-title="`导出`"
                    style="margin: 0 10px;"/>
        <el-button type="danger" size="mini" @click="batchDelete" v-if="userAuth.can_delete_customer_info"
                   icon="el-icon-delete" :disabled="multiple">删除
        </el-button>
        <el-button v-if="userAuth.manage_year_frame_apply" size="mini" type="primary" @click="goYearFrame"
                   icon="el-icon-tickets">年框申请列表
        </el-button>
      </div>
      <div>
        <div v-loading="loading"
             element-loading-text="数据加载中……"
             element-loading-spinner="el-icon-loading" class="default-table">
          <el-table
              :data="dataList"
              style="width: 100%"
              ref="customerTable"
              :row-class-name="tableRowClassName"
              @selection-change="handleSelectionChange"
              class="data-table" border>
            <el-table-column type="selection" width="55"/>
            <el-table-column
                label="序号"
                align="center"
                min-width="80">
              <template slot-scope="{$index,row}">
                <span :title="row.id">{{ offset + ($index + 1) }}</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="customer_name"
                label="客户名称"
                min-width="200"
                header-align="center"
                align="left"
                :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <div class="customer-name">
                  <el-link type="primary" @click="jumpToDetail(scope.row)" :title="`曾用名：${scope.row.customer_name}`">
                    {{ scope.row.name }}
                  </el-link>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="集团" align="center" :show-overflow-tooltip="true" min-width="100">
              <template slot-scope="{row}">
                <store-combine :data="{id:row.customer_id,name:row.customer_name,combine_name:row.combine_name}"
                               @success="onSubmit"/>
              </template>
            </el-table-column>
            <el-table-column
                prop="year_frame"
                label="年框"
                header-align="center"
                align="center"
                min-width="110"
                :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span class="span-btn" @click="handelToYearFrame(scope.row)">
                  <template v-if="scope.row.year_frame === 'Y'"><i class="el-icon-star-on"/>年框</template>
                  <template v-else><i class="el-icon-star-off"/>非年框</template>
                </span>
              </template>
            </el-table-column>
            <el-table-column
                prop="is_new"
                label="新客"
                header-align="center"
                align="center"
                min-width="80"
                :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.is_new === 'Y'"><i class="el-icon-star-on"></i>是</span>
                <span v-else><i class="el-icon-star-off"></i>否</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="sale"
                label="销售"
                align="center"
                min-width="100">
            </el-table-column>
            <el-table-column
                prop="nature"
                label="客户性质"
                align="center"
                min-width="100">
            </el-table-column>
            <el-table-column
                prop="grade"
                label="客户级别"
                align="center"
                min-width="100">
            </el-table-column>
            <el-table-column
                prop="credit"
                label="客户信用"
                align="center"
                :show-overflow-tooltip="true"
                min-width="100">
              <template slot-scope="{row}">
                <store-credit :data="{id:row.customer_id,name:row.customer_name,credit:row.credit}"
                              @success="onSubmit"/>
              </template>
            </el-table-column>
            <el-table-column
                prop="type"
                label="行业"
                align="center"
                min-width="100">
            </el-table-column>
            <el-table-column
                prop="brands"
                label="(数量)品牌"
                header-align="center" align="left"
                min-width="180" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <span>{{ scope.row.brand_str }}</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="address"
                label="地址"
                min-width="240">
              <template slot-scope="scope">
                  <span>{{ scope.row.province }}  {{ scope.row.city }} {{ scope.row.area }} {{
                      scope.row.address
                    }}</span>
              </template>
            </el-table-column>
            <el-table-column key="操作项" label="操作项" align="center" width="160" fixed="right">
              <template slot-scope="scope">
                <div class="buttons d-flex-row align-items-center">
                  <el-button type="text" @click="goEdit(scope.row.id)" size="mini"
                             :disabled="!(userAuth.can_edit_customer_info_sale || userAuth.can_update_customer_info)">
                    <i class="el-icon-edit"></i>编辑
                  </el-button>
                  <el-button type="text" @click="customFollow(scope.row)" size="mini"
                             :disabled="!(userAuth.option_update_customer_info)">
                    <i class="el-icon-document-checked"></i>跟进
                  </el-button>
                  <el-button type="text" @click="rowDel(scope.row,scope.$index)" size="mini"
                             :disabled="!(userAuth.can_delete_customer_info)">
                    <i class="el-icon-delete"></i>删除
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <Pagination
              v-show="total>0"
              :total="total"
              :page.sync="searchCondition.page"
              :limit.sync="searchCondition.per_page"
              @pagination="initList"
          />
        </div>
      </div>
    </div>
    <el-dialog title="跟进记录" :visible.sync="dialogTableVisible" style="height: 85%">
      <el-form :model="recordForm" label-width="80px" style="text-align:left;padding:40px 0;" size="mini">
        <el-form-item label="跟进时间" style="width:80%;margin:0 auto 20px">
          <el-date-picker
              v-model="recordForm.follow_timestamp"
              type="date"
              format="yyyy-MM-dd"
              value-format="timestamp"
              change="dateChange"
              placeholder="选择跟进时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="记录内容" style="width:80%;margin:0 auto 40px">
          <el-input type="textarea" :row="4" v-model="recordForm.record_content" placeholder="请输入记录内容"
                    maxlength="300" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="跟进记录" style="width:80%;margin:0 auto 40px" v-if="follow_record.length">
          <div class="content" style="height:200px;overflow:auto">
            <template v-for="item in follow_record">
              <div :key="item.id" style="padding-bottom: 20px;">
                <div>{{ item.updated_at }}</div>
                <div>记录人：{{ item.creator }}</div>
                <div>跟进时间： {{ item.follow_timestamp }}</div>
                <div>跟进记录：{{ item.record_content }}</div>
              </div>
            </template>
          </div>
        </el-form-item>

        <div style="text-align:center;">
          <el-button type="primary" @click="addRecord" class="el-button--operation"
                     style="margin-right: 50px;">添加记录
          </el-button>
          <el-button @click="dialogTableVisible = false">取消</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>

import {getOptionItems} from '@/api/option'
import {
  deleteSaleCustom,
  addRecord,
  recordList,
  getSellerCustomers,
  exportSellerCustomers,
} from "@/api/customers";
import ExportBtn from "@/components/export/ExportBtn";
import StoreCredit from "./components/StoreCredit";
import StoreCombine from "./components/StoreCombine";

export default {
  name: "myCustom",
  components: {ExportBtn, StoreCredit, StoreCombine},
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    pid: Number
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
    user() {
      return this.$store.getters.getUser;
    },
    headerToken() {
      return {
        Authorization: "Bearer " + this.getToken()
      }
    },
  },
  data() {
    return {
      loading: false,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 总条数
      total: 0,
      offset: 0,
      searchCondition: {
        sale_id: null,
        customer_id: null, //客户名称ID
        customer_name: null, //客户名称
        nature: null,
        grade: null, //搜索条件 最高报价
        sale: null,
        type: null,
        combine_name: null,
        year_frame: [],
        is_new: [],
        page: 1,
        per_page: 20
      },
      dataList: [],
      dialogTableVisible: false,
      tableLoading: true,
      optionsItem: ["customer_types", "customer_grades", "customer_natures"],
      customer_grades: {},
      customer_natures: {},
      customer_types: {},
      recordForm: {
        follow_timestamp: '',
        record_content: '',
        customer_id: '',
        sale_id: '',
      },
      currentRow: {},
      follow_record: [],
      selectList: [],
      sort: {
        order: '',
        prop: ''
      },
      multipleSelection: [],
      currentCustomer: {},
      dialogYfBool: false,
      formYf: {id: null, timeRange: []},
      applyYearFrameDialog: false,
      applyYearFrameTheCustomer: false,
    };
  },
  created() {
    this.getOptions(this.optionsItem);
  },
  mounted() {
    this.onSubmit();
  },
  methods: {
    tableRowClassName({row, rowIndex}) {
      // // 把每一行的索引放进row.id
      row.index = rowIndex + 1
    },
    // 勾选事件
    handleSelectionChange(selection) {
      this.selectList = selection
      this.ids = selection.map(item => item.id)
      this.single = selection.length !== 1
      this.multiple = !selection.length
    },
    onSubmit() {
      this.searchCondition.page = 1
      this.initList();
    },
    getOptions(options) {
      getOptionItems(options).then(res => {
        this.customer_grades = res.model.customer_grades || {};
        this.customer_natures = res.model.customer_natures || {};
        this.customer_types = res.model.customer_types || {};
      });
    },
    // 重置
    onReset() {
      this.searchCondition = {
        sale_id: null,
        customer_id: null, //客户名称ID
        customer_name: null, //客户名称
        nature: null,
        grade: null, //搜索条件 最高报价
        sale: null,
        type: null,
        combine_name: null,
        year_frame: [],
        is_new: [],
        page: 1,
        per_page: 20
      };

      this.onSubmit();
    },
    // 去创建
    goCustom() {
      const {href} = this.$router.resolve({
        name: `addCustom`
      });
      window.open(href, "_blank");
    },
    // 去编辑
    goEdit(id) {
      const {href} = this.$router.resolve({
        name: `editCustom`,
        params: {id: id}//customer_id: row.customer_id, sale_id: row.sale_id
      });
      window.open(href, "_blank");
    },
    jumpToDetail(row) {
      const {href} = this.$router.resolve({
        name: `detailCustom`,
        query: {id: row.customer_id, sale_id: row.sale_id}//customer_id: row.customer_id, sale_id: row.sale_id
      });
      window.open(href, "_blank");
    },
    // 回调客户信息
    goSelect(row) {
      this.$emit('rowSelect', row)
    },
    //客户跟进
    customFollow(row) {
      this.recordForm.customer_id = row.customer_id;
      this.recordForm.sale_id = row.sale_id;
      this.getRecordList()
      this.dialogTableVisible = true;
    },
    //添加记录
    addRecord() {
      this.recordForm.follow_timestamp = String(this.recordForm.follow_timestamp / 1000)
      this.recordForm.customer_id = String(this.recordForm.customer_id)
      // eslint-disable-next-line
      addRecord(this.recordForm).then(res => {
        this.showToast({h: this, text: '添加成功'})
        this.recordForm.follow_timestamp = null
        // this.dialogTableVisible = false
        this.getRecordList()
      })
    },
    // 被选择的表格项删除
    async setDeleteRow() {
      let _idList = [];
      for (let index = 0; index < this.selectList.length; index++) {
        _idList.push(this.selectList[index].id);
      }
      // eslint-disable-next-line
      const response = await deleteSaleCustom({ids: _idList})
      if (!response.success) {
        this.showToast({
          h: this,
          icon: "el-icon-error",
          text: response.message,
          duration: 2000
        })
        return false
      }

      this.showToast({
        h: this,
        icon: "el-icon-success",
        text: "删除成功",
        duration: 2000
      });
      this.initList();
    },
    //选中一行或者取消选中
    selectRow(index, bool) {
      // 勾选当前行，触发事件handleSelectionChange，把要删除的数据存入selectList
      this.$refs.customerTable.toggleRowSelection(
          this.dataList[index],
          bool
      )
    },
    batchDelete() {
      if (this.selectList.length > 0) {
        let that = this;
        this.showModal({
          h: this,
          text: "确定删除吗",
          confirmText: "",
          cancelText: "",
          confirm: function () {
            that.setDeleteRow();
          },
          cancel: function () {

          }
        });
      } else {
        this.$message.warning('至少勾选一行')

      }
    },
    // 单个表格项被选中删除
    rowDel(row, index) {
      // let index = row.index
      this.selectRow(index, true)

      let that = this;
      this.showModal({
        h: this,
        text: "确定删除吗",
        confirmText: "",
        cancelText: "",
        confirm: function () {
          that.setDeleteRow();
        },
        cancel: function () {
          that.selectRow(index, false)
        }
      });
    },
    //导出
    async exportExcel(refName) {
      try {
        // this.$notify.info(refName)
        const searchCondition = this.handleSearchCondition()
        let name = '我的客户'

        const response = await exportSellerCustomers(searchCondition).then(response => {
          return response
        })

        this.$refs[refName].exportSaveXlsx(response, name)

      } catch (e) {
        this.$message.warning('导出异常，请联系管理员')
        // alert(JSON.stringify(e))
      }

    },
    //客户列表查询
    initList() {
      this.loading = true
      this.dataList = []
      const pagingInfo = {page: this.searchCondition.page, per_page: this.searchCondition.per_page}
      const searchCondition = this.handleSearchCondition()
      Object.assign(searchCondition, pagingInfo)
      getSellerCustomers(searchCondition).then((res) => {
        this.loading = false
        if (res.model) {
          let pageData = res.model
          this.dataList = pageData.data || []
          this.total = pageData.total * 1
          this.offset = pageData.offset * 1
          this.searchCondition.per_page = pageData.per_page * 1
        }
      });
    },
    // 处理搜索条件
    handleSearchCondition() {
      const condition = {}

      if (this.searchCondition.customer_id) {
        condition.customer_id = this.searchCondition.customer_id
      }
      if (this.searchCondition.customer_name) {
        condition.customer_name = this.searchCondition.customer_name
      }
      if (this.searchCondition.sale_id) {
        condition.sale_id = this.searchCondition.sale_id
      }
      if (this.searchCondition.sale) {
        condition.sale = this.searchCondition.sale
      }
      if (this.searchCondition.nature) {
        condition.nature = this.searchCondition.nature
      }
      if (this.searchCondition.type) {
        condition.type = this.searchCondition.type
      }
      if (this.searchCondition.grade) {
        condition.grade = this.searchCondition.grade
      }
      if (this.searchCondition.year_frame && this.searchCondition.year_frame.length > 0) {
        condition.year_frame = this.searchCondition.year_frame
      }
      if (this.searchCondition.is_new && this.searchCondition.is_new.length > 0) {
        condition.is_new = this.searchCondition.is_new
      }
      if (this.searchCondition.combine_name) {
        condition.combine_name = this.searchCondition.combine_name
      }

      return condition
    },

    getRecordList() {
      this.follow_record = []
      recordList({sale_id: this.recordForm.sale_id, customer_id: this.recordForm.customer_id}).then(res => {
        this.follow_record = res.model
      })
    },
    async toApplyYearFrame(customer, type = 'TO_Y') {
      customer = {...{}, ...customer}
      this.applyYearFrameTheCustomer = customer;
      this.applyYearFrameDialog = true;
      this.applyYearFrameTheCustomer.type = type;
    },
    goYearFrame() {
      this.$router.push({name: 'yearFrameProposer', query: {hand: 'proposer'}})
    },
    /**
     * 客户年框详情
     * @param row
     */
    handelToYearFrame(row) {
      const {href} = this.$router.resolve({
        name: 'detailCustom',
        query: {id: row.customer_id, sale_id: row.sale_id, tab: 'YEAR_FRAME'}
      });
      window.open(href, "_blank");
    }
  }
};
</script>
<style scoped>

</style>
<style lang="scss">
.customer-seller-container {
  .el-button--text {
    padding: 0;
  }

  .customer-name {
    display: flex;
    align-items: center;

    .combine-span {
      font-size: 12px;
      margin-left: 4px;
      width: 20px;
      height: 20px;
      background: red;
      text-align: center;
      color: antiquewhite;
      border-radius: 10px;
    }
  }

  .search-form {
    margin-bottom: 6px;

    .el-form-item {
      margin-bottom: 6px !important;
    }
  }
}
</style>
